module.exports = __webpack_public_path__ + "static/2-cursos-88976fc955bdf13a31e9e33eaeefa915.jpg";